<template>
    <div>
        <h2>{{slide.type}} Question:</h2>
        <hr>
        <quill-editor
            ref="quillSAQuestionEditor"
            @blur="saveSlide()"
            v-model="slide.slide.corpus"
            :options="{'placeholder': 'Write question here...'}"
        ></quill-editor>
        <ResourceGallery :resourceList="slide.slide.resources" v-on:saveSlide="saveSlide(false)"></ResourceGallery>
        <hr>
        <h2>Answer:</h2>
        <quill-editor
            ref="quillSAAnswerEditor"
            @blur="saveSlide()"
            v-model="slide.answer"
            :options="{'placeholder': 'Write answer here...'}"
        ></quill-editor>
        <CitationManager :citations="slide.slide.citations" @save="saveSlide(false)"/>
        <ResourceGallery :resourceList="slide.a_resources" v-on:saveSlide="saveSlide(false)"></ResourceGallery>
        <hr>
        <md-button class="md-raised md-primary" @click="saveSlide(true)" style="background-color: green">
            Save
        </md-button>
        <md-button class="md-raised md-accent md-icon-button slide-delete-btn" @click="deleteSlide()">
            <md-icon>delete_forever</md-icon>
        </md-button>
    </div>
</template>

<script>

import ResourceGallery from './Gallery.vue'
import CitationManager from './CitationManager.vue'

export default {
    props: {
        slide: {
            type: Object
        },
    },
    data: function(){
        return {
            answer: "",
        }
    },
    components: {
        ResourceGallery,
        CitationManager,
    },
    methods: {
        saveSlide: function(closeSlide) {
            this.$emit('saveSlide', [this.slide, closeSlide])
        },
        deleteSlide: function(){
            this.$emit('deleteSlide', this.slide)
        },
        clearQuillHistory() {
            this.$refs.quillSAQuestionEditor.quill.history.clear();
            this.$refs.quillSAAnswerEditor.quill.history.clear();
        }
    },
    mounted() {
        this.$nextTick(function(){
            this.clearQuillHistory();
        })
    },
    watch: {
        "slide.id"() {
            setTimeout(() => {
                this.clearQuillHistory();
            }, 500)
        }
    }
}
</script>

<style scoped>
.md-field{
    max-width: 80%;
    margin: auto;
    margin-bottom: 40px;
}
</style>